import React from 'react';
import Order from '../../views/orderAction';
import '../../less/order';
import {Control} from 'MWC';
import iconKdv from '../../img/card_kdv.jpg';

export default function template() {
    return (
        <div className="module-cards-order">
            <div className="content">
                <div className="landing">
                    <Control>
                        <h1>{this.l10n('CARDS_ORDER_NAME_KDV')}</h1>
                    </Control>
                    <div className="feature__list">
                        <ul>
                            <li>
                                {this.l10n('CARDS_FEATURE_CURRENCY_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_CURRENCY_KDV')}
                            </li>
                            <li>
                                {this.l10n('CARDS_FEATURE_LOCATION_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_LOCATION_KDV')}
                            </li>
                            <li>
                                {this.l10n('CARDS_FEATURE_MANAGER_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_MANAGER_KDV')}
                            </li>
                            <li>
                                {this.l10n('CARDS_FEATURE_COST_LABEL')}: &nbsp;
                                {this.l10n('CARDS_FEATURE_COST_KDV')}
                            </li>
                        </ul>
                    </div>
                    <Control>
                        <div className="order-step__list">
                            <div className="order-step__item one">
                                {this.l10n('CARDS_ORDER_STEP_ONE')}
                            </div>
                            <div className="order-step__arrow" />
                            <div className="order-step__item two">
                                {this.l10n('CARDS_ORDER_STEP_TWO')}
                            </div>
                            <div className="order-step__arrow" />
                            <div className="order-step__item three">
                                {this.l10n('CARDS_ORDER_STEP_THREE')}
                            </div>
                        </div>
                    </Control>
                </div>
                <div className="order">
                    <Control>
                        <h3>{this.l10n('CARDS_ORDER_TYPE_KDV')}</h3>
                    </Control>
                    <Control>
                        <Order {...this.props} type="uni" />
                    </Control>
                    <div>
                        <img src={iconKdv} width={320} />
                    </div>
                </div>
            </div>
        </div>
    );
}
